import { Component, OnInit, Input } from '@angular/core';
import { DataService } from '../../../data.service';

@Component({
  selector: 'lc-account-general-info',
  templateUrl: './account-general-info.component.html',
  styleUrls: ['./account-general-info.component.scss']
})
export class AccountGeneralInfoComponent implements OnInit {
  @Input() edit = false;
  @Input() new = false;

  saving = false;
  prev_address: string;

  constructor(public dataService: DataService) { }

  ngOnInit() {
    this.check_address();
  }

  ngOnChanges(change){
        this.check_address();
  }

  check_address(){
    if( !this.dataService.user_info ){
      this.dataService.address_complete = false;
    } else {
      this.dataService.address_complete = !!this.dataService.user_info.company &&
        !!this.dataService.user_info.address &&
        !!this.dataService.user_info.postalcode &&
        !!this.dataService.user_info.city;

      // this.edit = !!this.dataService.user_info && this.dataService.user_info.status == 'LEAD';
    }
    // return this.address_complete;
  }

  change_address(){
    this.saving = true;

    let new_user_info = JSON.stringify( this.dataService.user_info );
    if( new_user_info === this.prev_address) {// nothing was changed
      this.edit = false;
      this.saving = false;
    }

    // handle invalid VAT nummers (to short !)
    if( !!this.dataService.user_info.invoice_vatnumber && this.dataService.user_info.invoice_vatnumber.length < 10){
      this.dataService.user_info.invoice_vatnumber = "";
      this.dataService.user_info.invoice_vatpercentage = "";
    }

    this.dataService.updateUserInfo(this.dataService.user_info).subscribe((userinfo)=>{
      this.dataService.user_info = userinfo;
      this.prev_address = JSON.stringify( this.dataService.user_info);
      this.edit = false;
      this.saving = false;
    })
  }
}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/account-management/account-general-info/account-general-info.component.ts